// extracted by mini-css-extract-plugin
module.exports = {"rightContent":"styles_rightContent__3ikSH","table":"styles_table__4GevC","gameBoost42":"styles_gameBoost42__2CVMW","row":"styles_row__2Rd_d","deleted":"styles_deleted__zbi_O"};